import React from 'react';
import styled from 'styled-components';
import { Text, spacer16, spacer24, spacer8, } from '@spotify-internal/encore-web';
import { TextLink } from '../../../../../LinkV2';
import { trackCat } from '../../../../constants';
const sanitizeEyebrow = (eyebrow) => {
    const LENGTH_LIMIT = 25;
    if (eyebrow.length > LENGTH_LIMIT) {
        console.error(`CategoryLinkList: eyebrow exceeded maximum threshold of ${LENGTH_LIMIT}`);
    }
    return eyebrow.substring(0, LENGTH_LIMIT);
};
const sanitizeCategoryLinks = (categoryLinks) => {
    const ITEM_LIMIT = 6;
    const LINK_LENGTH_LIMIT = 20;
    if (categoryLinks.length > ITEM_LIMIT) {
        console.error(`CategoryLinkList: categoryLinks exceeded maximum threshold of ${ITEM_LIMIT}`);
    }
    return categoryLinks
        .filter((_, i) => i < ITEM_LIMIT)
        .map(link => {
        if (link.label.length > LINK_LENGTH_LIMIT) {
            console.error(`CategoryLinkList: link label exceeded maximum threshold of ${LINK_LENGTH_LIMIT}`);
        }
        return Object.assign(Object.assign({}, link), { label: link.label.substring(0, LINK_LENGTH_LIMIT) });
    });
};
const CategoryLinkListSection = styled.section `
  & nav {
    list-style: none;
    padding: 0;
    margin: 0;
    margin-top: ${spacer24};
    & li {
      margin-bottom: ${spacer8};
      & a {
        padding: 0;
      }
    }

    & li:first-of-type {
      margin-bottom: ${spacer16};
    }
  }
`;
const EyebrowLabel = styled(Text).attrs({
    variant: 'bodySmall',
    semanticColor: 'textSubdued',
}) ``;
export const CategoryLinkList = ({ eyebrow, categoryLink, subLinks = [], }) => {
    const sanitizedEyebrow = sanitizeEyebrow(eyebrow);
    const sanitizedCategoryLink = sanitizeCategoryLinks([categoryLink]);
    const sanitizedSubLinks = sanitizeCategoryLinks(subLinks);
    return (React.createElement(CategoryLinkListSection, null,
        React.createElement(EyebrowLabel, null, sanitizedEyebrow),
        React.createElement("nav", null,
            React.createElement("li", { key: 0 },
                React.createElement(TextLink, Object.assign({ size: "medium" }, sanitizedCategoryLink[0], { trackingCategory: trackCat }))),
            sanitizedSubLinks.map((link, index) => (React.createElement("li", { key: index + 1 },
                React.createElement(TextLink, Object.assign({ size: "small" }, link, { trackingCategory: trackCat }))))))));
};
//# sourceMappingURL=index.js.map